/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunicationProperties } from '../../models/communication-properties';
import { UpdateCommunicationPropertiesRequest } from '../../models/update-communication-properties-request';

export interface Update$Params {
  organizationId: string;
  operationId: string;
  
    /**
     * Operation within a communication properties record to be updated.
     */
    body: UpdateCommunicationPropertiesRequest
}

export function update(http: HttpClient, rootUrl: string, params: Update$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunicationProperties>> {
  const rb = new RequestBuilder(rootUrl, update.PATH, 'put');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('operationId', params.operationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CommunicationProperties>;
    })
  );
}

update.PATH = '/v1/organizations/{organizationId}/configuration/communication-properties/operation/{operationId}';
